import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OtpInputComponent } from './otp-input/otp-input.component';

@NgModule({
  declarations: [OtpInputComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule // Added MatFormFieldModule for mat-form-field
  ],
  exports: [OtpInputComponent]
})
export class ShareModule { }